var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C9.23858 2 7 4.23858 7 7.00002C7 9.76147 9.2386 12 12 12C14.7615 12 17 9.76145 17 7.00002C17 4.2386 14.7615 2 12 2ZM9 7.00002C9 5.34315 10.3432 4 12 4C13.6569 4 15 5.34313 15 7.00002C15 8.65689 13.6569 10 12 10C10.3431 10 9 8.65687 9 7.00002ZM4 19.4C4 17.5222 5.52223 16 7.4 16H16.6C18.4778 16 20 17.5222 20 19.4C20 19.7314 19.7314 20 19.4 20H4.6C4.26863 20 4 19.7314 4 19.4ZM7.4 14C4.41766 14 2 16.4177 2 19.4C2 20.8359 3.16406 22 4.6 22H19.4C20.8359 22 22 20.8359 22 19.4C22 16.4177 19.5823 14 16.6 14H7.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsBlack);
export default __webpack_public_path__ + "static/media/clientsBlack.77ba5eebd1d8064d289bca8178015186.svg";
export { ForwardRef as ReactComponent };